/* Localize the store's existing consent text without changing consent behavior. */
(function () {
  var locale = String(document.documentElement.lang || '').toLowerCase().split('-')[0];
  var copy = {
    fr: {message: 'J’ai lu et j’accepte les {link}', link: 'conditions générales de vente', error: 'Veuillez accepter les conditions générales de vente avant de passer commande.', title: 'Conditions générales de vente', proceed: 'Passer au paiement', time: 'Conditions acceptées le'},
    en: {message: 'I have read and agree to the {link}', link: 'terms and conditions', error: 'Please agree to the terms and conditions before placing your order.', title: 'Terms and conditions', proceed: 'Proceed to checkout', time: 'Terms accepted on'},
    de: {message: 'Ich habe die {link} gelesen und stimme ihnen zu.', link: 'Allgemeinen Geschäftsbedingungen', error: 'Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen zu, bevor Sie Ihre Bestellung aufgeben.', title: 'Allgemeine Geschäftsbedingungen', proceed: 'Zur Kasse', time: 'Bedingungen akzeptiert am'},
    nl: {message: 'Ik heb de {link} gelezen en ga ermee akkoord.', link: 'algemene voorwaarden', error: 'Accepteer de algemene voorwaarden voordat u uw bestelling plaatst.', title: 'Algemene voorwaarden', proceed: 'Naar afrekenen', time: 'Voorwaarden geaccepteerd op'}
  }[locale];
  if (!copy) return;
  function localize(item) {
    if (!item || !item.param) return;
    var p = item.param;
    p.message = copy.message;
    p.error_message = copy.error;
    if (p.greeting) p.greeting.message = copy.error;
    if (p.time_label) p.time_label = copy.time;
    if (p.optional_message_value) p.optional_message_value = copy.proceed;
    if (p.links && p.links.link) {
      p.links.link.label = copy.link;
      p.links.link.url = location.origin + '/' + locale + '/pages/conditions-generales-de-vente';
    }
    if (item.popup) {item.popup.title = copy.title; item.popup.button = copy.proceed;}
  }
  function apply(config) {
    if (!config || !config.metafields) return;
    var m = config.metafields;
    if (Array.isArray(m.list)) m.list.forEach(localize);
    localize(m.settings);
  }
  var app = window.roarJs = window.roarJs || {};
  var current = app.LegalConfig;
  apply(current);
  Object.defineProperty(app, 'LegalConfig', {
    configurable: true,
    enumerable: true,
    get: function () {return current;},
    set: function (config) {current = config; apply(current);}
  });
})();
